import { IoIosCheckmarkCircle } from 'react-icons/io';
import { IoMdCloseCircle } from 'react-icons/io';
import { RxCalendar } from 'react-icons/rx';
import { booleanIcons, dateIcons } from './consts';

const getIconByBooleanValue = (value?: string | null) => {
    if (value === 'true') {
        return <IoIosCheckmarkCircle />;
    } else if (value === 'false') {
        return <IoMdCloseCircle />;
    }
    return null;
};

export const getValueIcon = (fieldName: string, value?: string | null) => {
    if (dateIcons.includes(fieldName)) {
        return <RxCalendar />;
    } else if (booleanIcons.includes(fieldName)) {
        return getIconByBooleanValue(value);
    }
    return null;
};
